module.exports = __webpack_public_path__ + "img/icon-menu.5a41c9f2.svg";